"use client";

import Autoplay from "embla-carousel-autoplay";
import Fade from "embla-carousel-fade";
import useEmblaCarousel from "embla-carousel-react";
import Image from "next/image";

const images = ["/fundidora.webp", "/port-de-barcelona-night.webp"];

const LoginCarousel = () => {
	const [emblaRef] = useEmblaCarousel(
		{
			loop: true,
			duration: 30,
		},
		[
			Autoplay({
				delay: 10000,
				stopOnInteraction: false,
				stopOnMouseEnter: false,
			}),
			Fade(),
		],
	);

	return (
		<div
			ref={emblaRef}
			className="absolute top-0 left-0 h-full w-full overflow-hidden rounded-none!"
		>
			<div className="flex h-full rounded-none!">
				{images.map((src, index) => (
					<div
						key={src}
						className="relative h-full min-w-0 flex-[0_0_100%] rounded-none!"
					>
						<Image
							src={src}
							alt={`Login background ${index + 1}`}
							fill
							priority={index === 0}
							style={{
								objectFit: "cover",
								borderRadius: 0,
							}}
						/>
						<div className="bg-primary/15 absolute inset-0 z-[1] rounded-none!" />
					</div>
				))}
			</div>
		</div>
	);
};

export default LoginCarousel;
